import { observer } from 'mobx-react';
import * as React from 'react';
import ChannelAvailabilityStore from '../Socket/ChannelAvailabilityStore';
import PresenceChannel from '../Socket/PresenceChannel';
import PresenceHandler from './PresenceHandler';

interface Props {
  channelName: string;
}

class NotificationPresence extends React.Component<Props, {}> {
  private channelAvailabilityStore: ChannelAvailabilityStore = new ChannelAvailabilityStore();

  render() {
    return (
      <>
        <PresenceChannel
          name={this.props.channelName}
          channelAvailabilityStore={this.channelAvailabilityStore}
        />
        <PresenceHandler channelAvailabilityStore={this.channelAvailabilityStore} />
      </>
    );
  }
}

export default observer(NotificationPresence);
